import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const config: Configuration = {
  auth: {
    authority:
      "https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3",
    clientId: "48c0c80f-5e24-40d4-af49-001b857f3cf8",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

// eslint-disable-next-line import/prefer-default-export
export const authProvider = new PublicClientApplication(config);
